import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import React, { memo } from 'react';

var _templateObject;
var StyledDropdownContainer = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var DropdownContainer = function DropdownContainer(props) {
  return /*#__PURE__*/React.createElement(StyledDropdownContainer, props);
};
var DropdownContainer$1 = /*#__PURE__*/memo(DropdownContainer);

export default DropdownContainer$1;
export { DropdownContainer };
